module.exports = {"ziModal":5000,"ziCookieConsent":4000};